import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  formValues: {},
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: create => ({
    setBookingFormValues: create.reducer((state, {payload}) => ({
      ...state,
      formValues: {
        ...state.formValues,
        ...payload,
      },
    })),
  }),
});

export const bookingState = state => state.auth;

export const {setBookingFormValues} = bookingSlice.actions;

export default bookingSlice.reducer;
